(function () {
  if (window.__twrdCardWishInit) return;
  window.__twrdCardWishInit = true;

  var SELECTOR = '[data-twrd-card-wish]';
  var KEY = 'twrd_wishlist';

  /* Fallback if the asset failed to load — same key, same item shape. */
  function store() {
    if (window.TwrdWishlist) return window.TwrdWishlist;
    return {
      has: function (h) {
        try {
          return JSON.parse(localStorage.getItem(KEY) || '[]')
            .some(function (p) { return p.handle === h; });
        } catch (_) { return false; }
      },
      toggle: function (item) {
        var list = [];
        try { list = JSON.parse(localStorage.getItem(KEY) || '[]') || []; } catch (_) {}
        var idx = -1;
        for (var i = 0; i < list.length; i++) {
          if (list[i].handle === item.handle) { idx = i; break; }
        }
        var added = idx < 0;
        if (added) list.unshift(item); else list.splice(idx, 1);
        try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (_) {}
        try {
          document.dispatchEvent(new CustomEvent('twrd:wishlist-changed', { detail: { count: list.length } }));
          document.dispatchEvent(new CustomEvent('twrd:wishlist:change', { detail: { count: list.length } }));
        } catch (_) {}
        return added;
      }
    };
  }

  function paint(btn) {
    var handle = btn.getAttribute('data-product-handle');
    var saved = handle ? store().has(handle) : false;
    btn.setAttribute('aria-pressed', saved ? 'true' : 'false');
    btn.setAttribute('aria-label', saved ? 'Remove from wishlist' : 'Save to wishlist');
  }

  function paintAll(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var buttons = scope.querySelectorAll(SELECTOR);
    for (var i = 0; i < buttons.length; i++) paint(buttons[i]);
  }

  /* Saving and removing get their own move, so the two never read alike. */
  function pop(btn, added) {
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    btn.removeAttribute('data-pop');
    void btn.offsetWidth;
    btn.setAttribute('data-pop', added ? 'add' : 'remove');
    setTimeout(function () { btn.removeAttribute('data-pop'); }, added ? 340 : 280);
  }

  /* Delegated — works for cards injected later (infinite scroll, quick-shop,
     predictive search, product recommendations). */
  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest ? e.target.closest(SELECTOR) : null;
    if (!btn) return;

    e.preventDefault();
    e.stopPropagation();
    if (e.stopImmediatePropagation) e.stopImmediatePropagation();

    var handle = btn.getAttribute('data-product-handle');
    if (!handle) return;

    var added = store().toggle({
      handle: handle,
      id: btn.getAttribute('data-product-id'),
      title: btn.getAttribute('data-product-title'),
      image: btn.getAttribute('data-product-image'),
      url: btn.getAttribute('data-product-url'),
      price: btn.getAttribute('data-product-price'),
      savedAt: Date.now()
    });

    btn.setAttribute('aria-pressed', added ? 'true' : 'false');
    btn.setAttribute('aria-label', added ? 'Remove from wishlist' : 'Save to wishlist');
    pop(btn, added);
    try { if (navigator.vibrate) navigator.vibrate(8); } catch (_) {}
  }, true);

  /* Stop the card link / quick-shop from reacting to the heart. */
  ['mousedown', 'mouseup', 'touchstart', 'touchend', 'pointerdown'].forEach(function (type) {
    document.addEventListener(type, function (e) {
      var btn = e.target && e.target.closest ? e.target.closest(SELECTOR) : null;
      if (btn) e.stopPropagation();
    }, true);
  });

  /* Quick-shop markup can be fetched remotely (placeholder mode) and then has
     no heart of its own. Clone the owning card's heart into it. */
  function ensureQuickShopHearts() {
    var panels = document.querySelectorAll('quick-shop .product-card__wrapper');
    for (var i = 0; i < panels.length; i++) {
      var panel = panels[i];
      if (panel.querySelector(SELECTOR)) continue;
      var qs = panel.closest('quick-shop');
      var card = qs ? qs.closest('product-card') : null;
      var source = card ? card.querySelector(SELECTOR) : null;
      if (!source) continue;
      var clone = source.cloneNode(true);
      clone.classList.add('twrd-card-wish--qs');
      clone.removeAttribute('data-pop');
      panel.appendChild(clone);
      paint(clone);
    }
  }

  function ready(fn) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn);
    else fn();
  }

  ready(function () {
    paintAll(document);
    ensureQuickShopHearts();

    document.addEventListener('twrd:wishlist:change', function () { paintAll(document); });
    document.addEventListener('twrd:wishlist-changed', function () { paintAll(document); });
    window.addEventListener('storage', function (e) {
      if (e.key === KEY) paintAll(document);
    });

    /* Cards added to the DOM after load get their state on arrival. */
    if (window.MutationObserver) {
      var pending = null;
      new MutationObserver(function (records) {
        for (var i = 0; i < records.length; i++) {
          if (records[i].addedNodes && records[i].addedNodes.length) {
            clearTimeout(pending);
            pending = setTimeout(function () {
              ensureQuickShopHearts();
              paintAll(document);
            }, 60);
            return;
          }
        }
      }).observe(document.documentElement, { childList: true, subtree: true });
    }
  });
})();
